import { createNativeStackNavigator } from '@react-navigation/native-stack';
import React from 'react';

import useHeaderScreenOptions from 'app/hooks/useHeaderScreenOptions';
import { useI18n } from 'app/providers/I18nProvider';
import PastTripsScreen from 'app/screens/PastTripsScreen';
import PurchaseOrderDetailsScreen from 'app/screens/PurchaseOrderDetailsScreen';
import PurchasesScreen from 'app/screens/PurchasesScreen';

export type PurchasesStackParamList = {
  PurchasesList: undefined;
  PurchaseOrderDetails: {
    entitlementKey: string;
  };
  PastTrips: undefined;
};

const Stack = createNativeStackNavigator<PurchasesStackParamList>();

export default function PurchasesStackNavigator() {
  const { t } = useI18n();
  const headerScreenOptions = useHeaderScreenOptions();

  return (
    <Stack.Navigator initialRouteName="PurchasesList" screenOptions={headerScreenOptions}>
      <Stack.Screen
        component={PurchasesScreen}
        name="PurchasesList"
        options={{
          title: t<string>('app_menu_my_purchases'),
          headerTitleAlign: 'center',
        }}
      />
      <Stack.Screen
        component={PurchaseOrderDetailsScreen}
        name="PurchaseOrderDetails"
        options={{
          title: t<string>('app_order_details_title'),
          headerTitleAlign: 'center',
        }}
      />
      <Stack.Screen
        component={PastTripsScreen}
        name="PastTrips"
        options={{
          title: t<string>('app_purchases_past_trips'),
          headerTitleAlign: 'center',
        }}
      />
    </Stack.Navigator>
  );
}
